import BaseController from "confinus_ui/base_controller";

export default class EntityFormController extends BaseController {
  public static targets = [
    "checkboxOther",
    "blockCustomType",
    "inputCustomType",
    "inputEmail",
    "blockEmailConfirmation",
    "inputEmailConfirmation",
  ];

  public static values = {
    originalEmail: { type: String, default: null },
  };

  declare private readonly originalEmailValue: string;

  declare private readonly checkboxOtherTarget: HTMLInputElement;
  declare private readonly inputCustomTypeTarget: HTMLInputElement;
  declare private readonly blockCustomTypeTarget: HTMLDivElement;
  declare private readonly inputEmailTarget: HTMLInputElement;
  declare private readonly blockEmailConfirmationTarget: HTMLDivElement;
  declare private readonly inputEmailConfirmationTarget: HTMLInputElement;

  public static classes = ["emailConfirmation"];

  declare private readonly emailConfirmationClasses: string[];

  public onInitialize() {
    this.handleOtherPropertyTypeChanges(false);
    this.handleEmailChanges();

    return super.onInitialize();
  }

  public handleEmailChanges() {
    if (this.inputEmailTarget.value === this.originalEmailValue) {
      this.setTargetElementClasses(
        this.blockEmailConfirmationTarget,
        [],
        this.emailConfirmationClasses,
      );
      this.inputEmailConfirmationTarget.value = "";
      this.inputEmailConfirmationTarget.disabled = true;
    } else {
      this.inputEmailConfirmationTarget.disabled = false;
      this.setTargetElementClasses(
        this.blockEmailConfirmationTarget,
        this.emailConfirmationClasses,
        [],
      );
    }
  }

  public handleOtherPropertyTypeChanges(focus = true) {
    if (this.checkboxOtherTarget.checked) {
      this.blockCustomTypeTarget.classList.remove("hidden");
      if (focus) {
        this.inputCustomTypeTarget.focus();
      }
    } else {
      this.blockCustomTypeTarget.classList.add("hidden");
    }
  }
}
